import { GridRowModes } from '@mui/x-data-grid';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selected: null,
    appsModesModel: {},
    rangesModesModel: {},
    editedRanges: [],
    editedApps: []
};

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        setSelected: (state, {payload}) => { 
            profileSlice.caseReducers.resetAppsModesModel(state);
            profileSlice.caseReducers.resetRangesModesModel(state);
            state.selected = payload; 
        },
        resetProfile: (state) => {
             state.selected =  null; 
             state.editedApps = [];
             state.editedRanges = [];
             profileSlice.caseReducers.resetAppsModesModel(state);
             profileSlice.caseReducers.resetRangesModesModel(state);
        },
        setAppsModesModel: (state, {payload}) => { state.appsModesModel = payload; },
        editAppsModesModel: (state, {payload}) => {
           state.appsModesModel = {...state.appsModesModel, ...payload}; 
        },
        resetAppsModesModel: (state) => { 
            Object.keys(state.appsModesModel).forEach((key) => state.appsModesModel[key] = {mode: GridRowModes.View, ignoreModifications: true});
        },
        
        setRangesModesModel: (state, {payload}) => { state.rangesModesModel = payload; },
        editRangesModesModel: (state, {payload}) => {
           state.rangesModesModel = {...state.rangesModesModel, ...payload};
        },
        resetRangesModesModel: (state) => {
            Object.keys(state.rangesModesModel).forEach((key) => state.rangesModesModel[key] = {mode: GridRowModes.View, ignoreModifications: true});
        },
        eraseRangesModesModel: (state) => {
            Object.keys(state.rangesModesModel).forEach((key) => delete state.rangesModesModel[key]);
        },
        setEditedRanges: (state, {payload}) => { state.editedRanges = payload},
        editEditedRanges: (state, {payload}) => {
            if(payload.deleted && payload.id.toString().charAt(0) === '-') {
                const index = state.editedRanges.findIndex(el => el.id === payload.id);
                if(index !== -1) {
                    state.editedRanges = [...state.editedRanges.slice(0, index), ...state.editedRanges.slice(index + 1)];    
                }
            }
            else state.editedRanges = [...state.editedRanges, payload]; 
        },
        setEditedApps: (state, {payload}) => { state.editedApps = payload}
    }
});

export const {
    setSelected,
    resetProfile,
    setAppsModesModel,
    setRangesModesModel,
    editAppsModesModel,
    editRangesModesModel,
    resetAppsModesModel,
    resetRangesModesModel,
    eraseRangesModesModel,
    setEditedApps,
    setEditedRanges,
    editEditedRanges
    
} = profileSlice.actions;

export default profileSlice.reducer;